export const DISTRIBUTION_LIST = [{
    label: 'Even Distribution',
    name: 'distribution',
    value: 2,
}, {
    label: 'Percentage by volume',
    name: 'distribution',
    value: 1,
}]